export default __webpack_public_path__ + "static/media/responsive_our_mission.611553d1.webp";